import axios from "axios";
import { ChangePasswordData } from "../../models/myPassword/myPassword.model";
import { UserData } from "../../models/login/login.model";
import { FormattedOwnerData } from "../../models/ownerData/ownerData.model";
import { API_ENDPOINTS } from "../../../config/endpoints.config";

const changePassword = async (
  userData: UserData,
  newPassword: string,
  ownerData: FormattedOwnerData
): Promise<void> => {
  const { token } = userData;
  const { isAdministrator, idAdministrator, idClient } = ownerData;
  const changePasswordData: ChangePasswordData = {
    userid: isAdministrator ? idAdministrator : idClient,
    newpassword: newPassword,
  };

  return axios
    .put(API_ENDPOINTS.USER_PASSWORD, changePasswordData, {
      headers: {
        Authorization: token,
      },
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });
};

export { changePassword };
